import React from "react";
import { IoSunnyOutline } from "react-icons/io5";
import { TbSunrise } from "react-icons/tb";

import SimpleButton from "@/components/Buttons/SimpleButton";
import { CardRow, CardRowActions, CardRowCell, CardRowCells } from "@/components/CardRow";

interface ConsortiumCardProps {
  name: string;
  powerPlantCount: number;
  onClick: () => void;
  onInvestmentsClick?: () => void;
}

const ConsortiumCard: React.FC<ConsortiumCardProps> = ({
  name,
  powerPlantCount,
  onClick,
  onInvestmentsClick,
}) => {
  return (
    <CardRow>
      <CardRowCells>
        <CardRowCell label="NOME" value={name} icon={<TbSunrise />} />
        <CardRowCell label="NÚMERO DE USINAS" value={powerPlantCount} icon={<IoSunnyOutline />} />
      </CardRowCells>
      <CardRowActions className="mr-0 pr-0">
        <SimpleButton variant="simple" label="Detalhes" onClick={onClick} />
        {onInvestmentsClick && (
          <SimpleButton variant="simple" label="Investimentos" onClick={onInvestmentsClick} />
        )}
      </CardRowActions>
    </CardRow>
  );
};

export default ConsortiumCard;
